import { render, staticRenderFns } from "./QRReader.vue?vue&type=template&id=5973c1a0&scoped=true&"
import script from "./QRReader.vue?vue&type=script&lang=js&"
export * from "./QRReader.vue?vue&type=script&lang=js&"
import style0 from "./QRReader.vue?vue&type=style&index=0&id=5973c1a0&scoped=true&lang=css&"
import style1 from "./QRReader.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5973c1a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VDialog,VIcon,VProgressCircular})
